import React from "react";

//import logo from './logo.svg';

import { Router, Switch, Route } from "react-router";
import { Link } from "react-router-dom";

import Header from "./components/Global/Header";
import Footer from "./components/Global/Footer";
import SubFooter from "./components/Global/SubFooter";
import Page404 from "./components/Global/Page404";
import Sucursales from "./components/Global/Sucursales";
import Empresa from "./components/Global/Empresa.js";
import TrabajaConNosotros from "./components/Global/TrabajaConNosotros.js";
import PromocionesBancarias from "./components/Global/PromocionesBancarias.js";
import Terminos from "./components/Global/Terminos.js";
import Reintegros from "./components/Global/Reintegros.js";
import ReservaFlexible from "./components/Global/ReservaFlexible.js";
import Contacto from "./components/Global/Contacto.js";
import FAQs from "./components/Global/FAQs.js";
import ScrollToTop from "./components/Global/ScrollToTop.js";
import FormasDePago from "./components/Global/FormasDePago.js";
import Carteleras from "./components/Global/Carteleras";
import BuscadorAgencias from "./components/Global/BuscadorAgencias";
import Home from "./components/Home";
import Resultados from "./components/Resultados";
import ProcesoCompra from "./components/ProcesoCompra";
import Login from "./components/Login";
import Registrar from "./components/Registrar";
import Activacion from "./components/Registrar/Activacion";
import {
  IniciarRecuperoPassword,
  ActivarPassword,
} from "./components/RecuperoPassword";
import TarifarioAgencia from "./components/TarifarioAgencia";

import MisReservas from "./components/MisReservas";
import MiPerfil from "./components/MiPerfil";
import Deposito from "./components/MisReservas/Deposito";
//import MercadoPago from './components/MisReservas/MercadoPago'
import FirstData from "./components/MisReservas/FirstData";
import Prisma from "./components/MisReservas/Prisma";
import { destinosAPI, productosAPI, toolsAPI } from "./utils/funcionesAPI";
//import { manejadorDeRespuesta } from './utils/Tools'
import { history } from "./utils/history";
//import ReactGA from 'react-ga'
import GAListener from "./utils/GAListener";
import { GlobalProvider } from "./context/globalContext";
import "react-toastify/dist/ReactToastify.css";

//import { CdrGlobalProvider } from "./context/cdrGlobalContext";
//import Hoteles from "./components/Hoteles/Home";
//import ResultadosCdr from "./components/Hoteles/ResultadosCdr";
//import LoginCdr from "./components/Hoteles/ProcesoCompraCdr/LoginCdr";
//import CargaPasajerosCdr from "./components/Hoteles/ProcesoCompraCdr/CargaPasajerosCdr";
//import FinalizacionCdr from "./components/Hoteles/ProcesoCompraCdr/FinalizacionCdr";
//import PagoCdr from "./components/Hoteles/ProcesoCompraCdr/PagoCdr";
import FranquiciaVirtual from "./components/Global/FranquiciaVirtual";
import { manejadorDeRespuesta } from "./utils/Tools";
import CoberturaSalud from "./components/Global/coberturaSalud";
//import ReactPixel from 'react-facebook-pixel';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      busqueda: {
        origen: "",
        destino: "",
        fecha: "",
        adultos: 2,
        menores: [],
        destinos: [],
        periodos: [],
        provincias: [],
        embarques: [],
        provinciaElegida: { codigo: "", puntosDeEmbarque: [] },
        puntoDeEmbarque: { idPuntoDeEmbarque: 0 },
        estadoBoton: true,
        tipoBusqueda: "porDestino",
      },
      ocultarBotonValijaYa: "0",
      productoSeleccionado: {},
      charterSeleccionado: {},
      pasajerosAdultos: [
        {
          tipoDocumento: { idTipoDocumento: 1, sigla: "DNI" },
          nacionalidad: { id: 1, denominacion: "Argentina" },
          sexo: "M",
          tipoPasajero: "Adulto",
        },
        {
          tipoDocumento: { idTipoDocumento: 1, sigla: "DNI" },
          nacionalidad: { id: 1, denominacion: "Argentina" },
          sexo: "M",
          tipoPasajero: "Adulto",
        },
      ],
      pasajerosMenores: [],
      usuario: {
        usuario: sessionStorage.getItem("usuario"),
        tipoCliente: sessionStorage.getItem("tipoCliente"),
        token: "",
      },
    };

    this.handleRadioCambiarTipoBusquedaChange =
      this.handleRadioCambiarTipoBusquedaChange.bind(this);
    this.handleCombosBusquedaChange =
      this.handleCombosBusquedaChange.bind(this);
    this.handleCombosBusquedaInicial =
      this.handleCombosBusquedaInicial.bind(this);
    this.handleCombosOrigenBusquedaChange =
      this.handleCombosOrigenBusquedaChange.bind(this);
    this.handleCombosDestinoBusquedaChange =
      this.handleCombosDestinoBusquedaChange.bind(this);
    this.handleComboPeriodoBusquedaChange =
      this.handleComboPeriodoBusquedaChange.bind(this);
    this.handleComboEmbarqueBusquedaChange =
      this.handleComboEmbarqueBusquedaChange.bind(this);
    this.handleAdultosChange = this.handleAdultosChange.bind(this);
    this.handleMenoresChange = this.handleMenoresChange.bind(this);
    this.handleEdadChange = this.handleEdadChange.bind(this);

    this.handleProductoClick = this.handleProductoClick.bind(this);
    this.handleCharterClick = this.handleCharterClick.bind(this);

    this.handlePasajeroAdultoChange =
      this.handlePasajeroAdultoChange.bind(this);
    this.handlePasajeroMenorChange = this.handlePasajeroMenorChange.bind(this);
    this.handleReservarClick = this.handleReservarClick.bind(this);

    this.handleLoginClick = this.handleLoginClick.bind(this);

    //  ReactGA.initialize('UA-54854159-9'); //Unique Google Analytics tracking number
    /*  ReactGA.initialize([{//Multiple Google Analytics tracking number
      trackingId: 'UA-54854159-9',
      gaOptions: {
        name: 'pedraza',
        userId: 123
      }
    }, {
     trackingId: 'UA-112090047-1',
     gaOptions: { name: 'avalon' }
   }], { debug: true, alwaysSendToDefaultTracker: false });*/

    /*  const advancedMatching = { }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
    const options = {
        autoConfig: true, 	// set pixel's autoConfig
        debug: false, 		// enable logs
    };*/
    //  ReactPixel.init('2203608086550716', advancedMatching, options);

    //  ReactPixel.track( event, data ) 		// For tracking default events, more info about events and data https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9
    //  ReactPixel.trackCustom( event, data ) 	// For tracking custom events
  }

  componentDidMount() {
    //this.traerDestinosPorOrigen(this.state.busqueda.origen);
    //this.traerDestinosPorOrigen(this.state.busqueda.origen);
    this.traerDestinosSinOrigen();
    this.validarEstadoDelSitio();
  }

  traerDestinosPorOrigen(origen) {
    let data = JSON.stringify({
      peticion: "traerDestinosSinOrigen",
      origen,
      canal: "web",
    });
    destinosAPI(data).then((respuesta) => {
      //if (manejadorDeRespuesta(this.props, respuesta)) {
      if (respuesta) {
        if (respuesta.estado !== "error") {
          let busqueda = Object.assign({}, this.state.busqueda);
          busqueda.destinos = respuesta.data;
          this.setState({ busqueda });
        }
      }
    });
  }

  traerDestinosSinOrigen() {
    let data = JSON.stringify({
      peticion: "traerDestinosSinOrigen",
      canal: "web",
    });
    destinosAPI(data).then((respuesta) => {
      //if (manejadorDeRespuesta(this.props, respuesta)) {
      if (respuesta) {
        if (respuesta.estado !== "error") {
          let busqueda = { ...this.state.busqueda };
          busqueda.destinos = respuesta.data;
          this.setState({ busqueda });
        }
      }
    });
  }

  traerResultadoParaBuscadorPorOrigen() {
    let data = JSON.stringify({
      accion: "traerResultadoParaBuscadorPorOrigen",
      canal: "WEB",
    });
    toolsAPI(data).then((respuesta) => {
      //if (manejadorDeRespuesta(this.props, respuesta)) {
      if (respuesta) {
        if (respuesta.estado !== "error") {
          let busqueda = { ...this.state.busqueda };
          //busqueda.provincias = respuesta.data;
          busqueda.embarques = respuesta.data;
          this.setState({ busqueda });
        }
      }
    });
  }

  validarEstadoDelSitio() {
    let data = JSON.stringify({ accion: "validarEstadoDelSitio" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(this.props, respuesta)) {
        if (!respuesta.data) {
          window.location = "https://pedraza.com.ar/enreparacion.png";
        } else {
          this.setState({
            ocultarBotonValijaYa: respuesta.data.botonPromoUltMomento,
          });
        }
      }
    });
  }

  traerPeriodosPorDestinos(codigo, origen) {
    let data = JSON.stringify({
      peticion: "traerMesesDeViajeDelDestino",
      origen: origen || "CENT",
      codigoDestino: codigo,
    });
    destinosAPI(data).then((respuesta) => {
      //if (manejadorDeRespuesta(this.props, respuesta)) {
      if (respuesta) {
        if (respuesta.estado !== "error") {
          let busqueda = Object.assign({}, this.state.busqueda);
          busqueda.periodos = respuesta.data;
          this.setState({ busqueda });
        }
      }
    });
  }

  traerOrigenPorDestinoYFecha(
    codigo,
    fecha,
    codigoProvinciaOrigenElegida,
    idPuntoDeEmbarqueElegido
  ) {
    let data = JSON.stringify({
      accion: "traerOrigenPorDestinoYFecha",
      fecha: fecha,
      codigoDestino: codigo,
    });
    toolsAPI(data).then((respuesta) => {
      //if (manejadorDeRespuesta(this.props, respuesta)) {
      if (respuesta) {
        if (respuesta.estado !== "error") {
          let busqueda = Object.assign({}, this.state.busqueda);
          busqueda.provincias = respuesta.data;
          if (codigoProvinciaOrigenElegida && idPuntoDeEmbarqueElegido) {
            busqueda.provinciaElegida = busqueda.provincias.find(
              (p) => p.codigo === codigoProvinciaOrigenElegida
            ) || { puntosDeEmbarque: [] };
            busqueda.puntoDeEmbarque =
              (busqueda.provinciaElegida &&
                busqueda.provinciaElegida.puntosDeEmbarque.find(
                  (p) => p.idPuntoDeEmbarque === idPuntoDeEmbarqueElegido
                )) ||
              {};
          }
          this.setState({ busqueda });
        }
      }
    });
  }

  traerProductoDeLosChartersQuePasanPorUnPuntoEmbarque(
    destino,
    fecha,
    idPuntoDeEmbarque
  ) {
    let data = JSON.stringify({
      peticion: "traerProductoDeLosChartersQuePasanPorUnPuntoEmbarque",
      destino,
      fecha,
      idPuntoDeEmbarque,
    });
    productosAPI(data).then((respuesta) => {
      //if (manejadorDeRespuesta(this.props, respuesta)) {
      if (respuesta) {
        if (respuesta.estado !== "error") {
          let busqueda = Object.assign({}, this.state.busqueda);
          busqueda.origen = respuesta.data.cabeceras;
          busqueda.estadoBoton = true;
          this.setState({ busqueda });
        }
      }
    });
  }

  //BUSQUEDA

  handleRadioCambiarTipoBusquedaChange(value) {
    let busqueda = Object.assign({}, this.state.busqueda);
    busqueda.destino = "";
    busqueda.provincias = [];
    busqueda.periodos = [];
    busqueda.fecha = "";
    busqueda.provinciaElegida = { codigo: "", puntosDeEmbarque: [] };
    busqueda.puntoDeEmbarque = { idPuntoDeEmbarque: 0 };
    busqueda.tipoBusqueda = value;
    busqueda.adultos = 2;
    this.setState({ busqueda });
    if (value === "porDestino") {
      this.traerDestinosSinOrigen();
    } else {
      this.traerResultadoParaBuscadorPorOrigen();
    }
  }

  handleCombosOrigenBusquedaChange(
    origen = { codigo: "", puntosDeEmbarque: [] }
  ) {
    let busqueda = Object.assign({}, this.state.busqueda);
    //busqueda.origen = origen;
    busqueda.provinciaElegida = origen;
    this.setState({ busqueda });
    //this.traerDestinosPorOrigen(origen);
  }

  handleCombosDestinoBusquedaChange(destino) {
    let busqueda = Object.assign({}, this.state.busqueda);
    busqueda.destino = destino;
    busqueda.fecha = "";

    if (busqueda.tipoBusqueda === "porDestino") {
      busqueda.provincias = [];
      busqueda.periodos = [];
      busqueda.provinciaElegida = { codigo: "", puntosDeEmbarque: [] };
      busqueda.puntoDeEmbarque = { idPuntoDeEmbarque: 0 };
      this.setState({ busqueda });
      this.traerPeriodosPorDestinos(destino, this.state.busqueda.origen);
    }

    if (busqueda.tipoBusqueda === "porOrigen") {
      const destinoEncontrado = busqueda.destinos.find(
        (d) => d.idDestino === destino
      );
      busqueda.periodos = destinoEncontrado && destinoEncontrado.periodos;
      this.setState({ busqueda });
    }
  }

  //FC: nuevos handles con provicias y embarques en el buscador
  handleComboPeriodoBusquedaChange(
    fecha,
    destino,
    codigoProvinciaOrigenElegida,
    idPuntoDeEmbarqueElegido
  ) {
    let busqueda = Object.assign({}, this.state.busqueda);
    busqueda.fecha = fecha;
    if (busqueda.tipoBusqueda === "porDestino") {
      busqueda.provincias = [];
      busqueda.provinciaElegida = { codigo: "", puntosDeEmbarque: [] };
      busqueda.puntoDeEmbarque = { idPuntoDeEmbarque: 0 };
      this.setState({ busqueda });
      this.traerOrigenPorDestinoYFecha(
        destino,
        fecha,
        codigoProvinciaOrigenElegida,
        idPuntoDeEmbarqueElegido
      );
    }

    if (busqueda.tipoBusqueda === "porOrigen") {
      this.setState({ busqueda });
      this.traerProductoDeLosChartersQuePasanPorUnPuntoEmbarque(
        busqueda.destino,
        busqueda.fecha,
        busqueda.puntoDeEmbarque.idPuntoDeEmbarque
      );
    }
  }

  handleComboEmbarqueBusquedaChange(
    puntoDeEmbarque = { idPuntoDeEmbarque: 0 }
  ) {
    let busqueda = Object.assign({}, this.state.busqueda);

    busqueda.puntoDeEmbarque = puntoDeEmbarque;
    //busqueda.origen = puntoDeEmbarque.sucursal;
    if (busqueda.tipoBusqueda === "porDestino") {
      busqueda.estadoBoton = false;
      this.setState({ busqueda });
      this.traerProductoDeLosChartersQuePasanPorUnPuntoEmbarque(
        busqueda.destino,
        busqueda.fecha,
        busqueda.puntoDeEmbarque.idPuntoDeEmbarque
      );
    }

    if (busqueda.tipoBusqueda === "porOrigen") {
      //busqueda.estadoBoton = false;
      busqueda.destinos = puntoDeEmbarque && puntoDeEmbarque.destinos;
      //FC: para la version del buscador sin elegir provincia
      busqueda.provinciaElegida = puntoDeEmbarque && puntoDeEmbarque.provincia;
      this.setState({ busqueda });
    }
  }

  handleCombosBusquedaChange(propiedad, valor) {
    let busqueda = Object.assign({}, this.state.busqueda);
    busqueda[propiedad] = valor;
    this.setState({ busqueda });
  }
  //FC: esta llamada viene de la pantalla Resultados
  handleCombosBusquedaInicial(
    fecha,
    destino,
    origen,
    codigoProvinciaOrigenElegida,
    idPuntoDeEmbarqueElegido
  ) {
    this.traerPeriodosPorDestinos(destino, this.state.busqueda.origen);
    let busqueda = Object.assign({}, this.state.busqueda);
    busqueda.origen = origen;
    this.setState({ busqueda });
    //this.handleCombosOrigenBusquedaChange(origen);
    this.handleCombosDestinoBusquedaChange(destino);
    this.handleComboPeriodoBusquedaChange(
      fecha,
      destino,
      codigoProvinciaOrigenElegida,
      idPuntoDeEmbarqueElegido
    );
    busqueda.fecha = fecha;
    busqueda.destino = destino;
    //busqueda.puntoDeEmbarque.idPuntoDeEmbarque = idPuntoDeEmbarqueElegido;
    //busqueda.puntoDeEmbarque = busqueda.provinciaElegida && busqueda.provinciaElegida.puntosDeEmbarque.find(p => p.idPuntoDeEmbarque = idPuntoDeEmbarqueElegido);
    //busqueda.provinciaElegida.codigo = codigoProvinciaOrigenElegida;
    this.setState({ busqueda });
  }

  handleAdultosChange(adultos) {
    let busqueda = Object.assign({}, this.state.busqueda); //creating copy of object
    //let pasajerosAdultos = Object.assign({}, this.state.pasajerosAdultos);
    let pasajerosAdultos = this.state.pasajerosAdultos.slice();
    busqueda.adultos = adultos;
    pasajerosAdultos = new Array(Number(adultos));
    pasajerosAdultos.fill({
      tipoDocumento: { idTipoDocumento: 1, sigla: "DNI" },
      nacionalidad: { id: 1, denominacion: "Argentina" },
      sexo: "M",
      tipoPasajero: "Adulto",
    });
    this.setState({ busqueda, pasajerosAdultos });
  }

  handleMenoresChange(menores) {
    let busqueda = Object.assign({}, this.state.busqueda); //creating copy of object
    //let pasajerosMenores = this.state.pasajerosMenores.slice();
    //let pasajerosMenores = Object.assign({}, this.state.pasajerosMenores);
    busqueda.menores = new Array(Number(menores));
    busqueda.menores.fill(0); // lo relleno con 0
    //pasajerosMenores = new Array(parseInt(menores));
    //pasajerosMenores.fill({tipoDocumento: {idTipoDocumento:1, sigla: 'DNI'}, nacionalidad: {id:1, denominacion: 'Argentina'}, sexo: 'M', tipoPasajero:'Menor', edad: 0});
    //const numHarrys = parseInt(menores);
    //pasajerosMenores = pasajerosMenores.map((e) => new Object());
    //harrys[3] = {tipoDocumento: {idTipoDocumento:1, sigla: 'DNI'}, nacionalidad: {id:1, denominacion: 'Argentina'}, sexo: 'M', tipoPasajero:'Menor', edad: 0};

    //  var numHarrys = 7;
    let pasajerosMenores = Array.apply(null, Array(parseInt(menores, 10))).map(
      () => new Menor()
    );
    //harrys[3] = {real: true};

    this.setState({ busqueda, pasajerosMenores });
  }

  handleEdadChange(clave, valor) {
    const indice = parseInt(clave, 10);
    let busqueda = Object.assign({}, this.state.busqueda); //creating copy of object
    //let pasajerosMenores = Object.assign({}, this.state.pasajerosMenores);
    let pasajerosMenores = this.state.pasajerosMenores.slice();
    busqueda.menores[indice] = valor;
    //pasajerosMenores[indice].edad = valor;
    let pasajero = pasajerosMenores[indice];
    pasajero.edad = valor;
    pasajerosMenores[indice] = pasajero;

    this.setState({ busqueda, pasajerosMenores });
  }
  //FIN BUSQUEDA

  //RESULTADOS

  handleProductoClick(producto) {
    let productoSeleccionado = Object.assign(
      {},
      this.state.productoSeleccionado
    );
    productoSeleccionado = producto;
    //FC: lo guardo en la sesion para que persista el dato al actualizar el navegador
    sessionStorage.setItem("producto", JSON.stringify(productoSeleccionado));
    this.setState({ productoSeleccionado });
  }

  handleCharterClick(charter) {
    let charterSeleccionado = Object.assign({}, this.state.charterSeleccionado);
    charterSeleccionado = charter;
    sessionStorage.setItem("charter", JSON.stringify(charterSeleccionado));
    sessionStorage.setItem(
      "pasajerosAdultos",
      JSON.stringify(this.state.pasajerosAdultos)
    ); //Fc: los guardo x las dudas
    sessionStorage.setItem(
      "pasajerosMenores",
      JSON.stringify(this.state.pasajerosMenores)
    );
    this.setState({ charterSeleccionado });
  }

  //FIN RESULTADOS

  //PASAJEROS

  handlePasajeroAdultoChange(indice, propiedad, valor) {
    let pasajeros = this.state.pasajerosAdultos.slice(); //creating copy of object
    //pasajerosAdultos[indice] = {[propiedad]: valor};
    let unPasajero = Object.assign({}, pasajeros[indice]);
    unPasajero[propiedad] = valor;
    pasajeros[indice] = unPasajero;
    //pasajerosAdultos[indice][propiedad] = valor;
    sessionStorage.setItem("pasajerosAdultos", JSON.stringify(pasajeros));
    this.setState({ pasajerosAdultos: pasajeros });
  }

  handlePasajeroMenorChange(indice, propiedad, valor) {
    let pasajeros = this.state.pasajerosMenores.slice(); //creating copy of object
    //pasajeros[indice] = {[propiedad]: valor};
    //pasajerosMenores[indice][propiedad] = valor;
    let unPasajero = Object.assign({}, pasajeros[indice]);
    unPasajero[propiedad] = valor;
    pasajeros[indice] = unPasajero;
    sessionStorage.setItem("pasajerosMenores", JSON.stringify(pasajeros));
    this.setState({ pasajerosMenores: pasajeros });
  }

  //RESERVAR

  handleReservarClick() {
    let pasajerosAdultos = this.state.pasajerosAdultos.slice();
    let pasajerosMenores = this.state.pasajerosMenores.slice();
    //sessionStorage.setItem('pasajeros', JSON.stringify(pasajeros));
    let productoSeleccionado = Object.assign(
      {},
      this.state.productoSeleccionado
    );

    let charterSeleccionado = Object.assign({}, this.state.charterSeleccionado);

    this.setState({
      pasajerosAdultos,
      pasajerosMenores,
      productoSeleccionado,
      charterSeleccionado,
    });
  }

  handleLoginClick() {
    console.log("App.js handleLoginClick: YA NO DEBERIA PASAR MAS POR ACA");
    let nombreUsuario = sessionStorage.getItem("usuario");
    let tipoCliente = sessionStorage.getItem("tipoCliente");
    let usuario = Object.assign({}, this.state.usuario);
    usuario.usuario = nombreUsuario;
    usuario.tipoCliente = tipoCliente;

    this.setState({ usuario });
  }

  render() {
    //FC: cuando quiero enviar parametros al componente en el ROUTE tengo que hacerlo mediante el render del Route
    const HomeConProps = (props) => {
      return (
        <Home
          busqueda={this.state.busqueda}
          onUpdateState={this.setState.bind(this)}
          onSelectChange={this.handleCombosBusquedaChange}
          onSelectOrigenChange={this.handleCombosOrigenBusquedaChange}
          onSelectDestinoChange={this.handleCombosDestinoBusquedaChange}
          onSelectPeriodoChange={this.handleComboPeriodoBusquedaChange}
          onSelectEmbarqueBusquedaChange={
            this.handleComboEmbarqueBusquedaChange
          }
          onSelectTipoBusquedaChange={this.handleRadioCambiarTipoBusquedaChange}
          onAdultosChange={this.handleAdultosChange}
          onMenoresChange={this.handleMenoresChange}
          onEdadChange={this.handleEdadChange}
        />
      );
    };

    const ProcesoCompraConProps = (props) => {
      return (
        <ProcesoCompra
          {...props}
          pasajeros={this.state.pasajeros}
          pasajerosAdultos={this.state.pasajerosAdultos}
          pasajerosMenores={this.state.pasajerosMenores}
          producto={this.state.productoSeleccionado}
          charter={this.state.charterSeleccionado}
          busqueda={this.state.busqueda}
          onPasajeroAdultoChange={this.handlePasajeroAdultoChange}
          onPasajeroMenorChange={this.handlePasajeroMenorChange}
          onReservarClick={this.handleReservarClick}
          onLoginClick={this.handleLoginClick}
        />
      );
    };

    const ResultadosConProps = (props) => {
      return (
        <Resultados
          {...props}
          busqueda={this.state.busqueda}
          pasajerosAdultos={this.state.pasajerosAdultos}
          onSelectChange={this.handleCombosBusquedaChange}
          onLoadEstadoInicial={this.handleCombosBusquedaInicial}
          onSelectOrigenChange={this.handleCombosOrigenBusquedaChange}
          onSelectDestinoChange={this.handleCombosDestinoBusquedaChange}
          onSelectPeriodoChange={this.handleComboPeriodoBusquedaChange}
          onSelectEmbarqueBusquedaChange={
            this.handleComboEmbarqueBusquedaChange
          }
          onSelectTipoBusquedaChange={this.handleRadioCambiarTipoBusquedaChange}
          onAdultosChange={this.handleAdultosChange}
          onMenoresChange={this.handleMenoresChange}
          onEdadChange={this.handleEdadChange}
          onProductoClick={this.handleProductoClick}
          onCharterClick={this.handleCharterClick}
        />
      );
    };

    const LoginConEstilos = (props) => {
      return (
        <section className="checkout-steps">
          <div className="container">
            <div className="row">
              <div className="content col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12">
                <Login
                  {...props}
                  onLoginClick={this.handleLoginClick}
                  mostrarToastContainer={true}
                />
                <div className="listado">
                  <Link to="/">Volver al inicio</Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    };

    // const history = createHistory();
    //FC lo mande al GAListener
    /*history.listen((location, action) => {
      ReactGA.set({ page: location.pathname }, ['pedraza','avalon']);
      ReactGA.pageview(location.pathname,['pedraza','avalon']);

      //FC: para Google Tag Manager de AVALON https://bernardodiasdacruz.com/2018/04/10/integrate-google-analytics-with-react-router-v4/
      if (location.hostname !== 'localhost') {
        const gtag = window.gtag
        //if (history.action === 'PUSH' && typeof (gtag) === 'function') {
          console.log('in func')
          gtag('config', 'AW-783256938', {
          'page_location': location.href,
          'page_path': location.pathname,
          });
        //}
      }
  });*/
    //FC: render si el componente es tuneado con propiedades
    //component es cuando llamo al componente sin mandarle propiedades adicionales
    return (
      <div className="notranslate">
        <Router history={history}>
          <GAListener>
            <ScrollToTop />
            <GlobalProvider>
              <Header
                usuario={this.state.usuario}
                origen={this.state.busqueda.origen}
                ocultarBotonValijaYa={this.state.ocultarBotonValijaYa}
              />

              <Switch>
                {/*<Route exact path='/nuevaWeb/front/' render={HomeConProps} />*/}
                <Route exact path="/" render={HomeConProps} />
                <Route path="/login" component={LoginConEstilos} />
                <Route exact path="/registracion" component={Registrar} />
                <Route
                  path="/registracion/activacion/:codigoActivacion"
                  component={Activacion}
                />
                <Route
                  exact
                  path="/recuperar-password"
                  component={IniciarRecuperoPassword}
                />
                <Route
                  path="/recuperar-password/:codigoValidacion/:idUsuarioWeb"
                  component={ActivarPassword}
                />
                {/* <Route
                  exact
                  path="/paquetes-turisticos/:origen/:destino/:fecha/:idProducto?/:idCharter?"
                  render={ResultadosConProps}
                /> */}
                <Route
                  exact
                  path="/paquetes-turisticos/:provincia/:idPuntoDeEmbarque/:origen/:destino/:fecha/:idProducto?/:idCharter?"
                  render={ResultadosConProps}
                />
                <Route
                  exact
                  path="/paquetes-turisticos/:provincia/:idPuntoDeEmbarque/:origen/:destino/:fecha/:idProducto?/:idGrupo?/:nombreGrupo?"
                  render={ResultadosConProps}
                />
                <Route
                  path="/paquetes-turisticos/:origen/:promociones"
                  render={ResultadosConProps}
                />

                {/*<Route path='/paquete-turistico/proceso-compra/:estado?/:numeroReserva?' render={ProcesoCompraConProps}  />*/}
                <Route
                  path="/paquete-turistico/proceso-compra/login/"
                  render={ProcesoCompraConProps}
                />
                <Route
                  path="/paquete-turistico/proceso-compra/carga-pasajeros/"
                  render={ProcesoCompraConProps}
                />
                <Route
                  path="/paquete-turistico/proceso-compra/pago/"
                  render={ProcesoCompraConProps}
                />
                <Route
                  path="/paquete-turistico/proceso-compra/finalizacion/:estado?/:numeroReserva?"
                  render={ProcesoCompraConProps}
                />
                {/*<Route path='/paquete-turistico/finalizacionReservaOficina/:nroReserva' component={FinalizacionReservaOficina}  />*/}
                {/*<Route path='/paquete-turistico/finalizacionReservaDeposito/:nroReserva' component={FinalizacionReservaDeposito}  />*/}

                <Route
                  exact
                  path="/panel-mis-reservas"
                  component={MisReservas}
                />
                <Route exact path="/mi-perfil" component={MiPerfil} />
                <Route path="/tarifario" component={TarifarioAgencia} />
                <Route
                  path="/panel-mis-reservas/informar-deposito/:nroReserva"
                  component={Deposito}
                />
                {/*<Route path='/panel-mis-reservas/mercadoPago/:nroReserva/:estado?' component={MercadoPago}  />*/}
                <Route
                  path="/panel-mis-reservas/firstData/:nroReserva/:estado?"
                  component={FirstData}
                />
                <Route
                  path="/panel-mis-reservas/prisma/:nroReserva/:estado?"
                  component={Prisma}
                />
                <Route path="/sucursales" component={Sucursales} />
                <Route path="/empresa" component={Empresa} />
                <Route path="/faqs" component={FAQs} />
                <Route
                  path="/trabajaConNosotros"
                  component={TrabajaConNosotros}
                />
                <Route
                  path="/franquiciaVirtual"
                  component={FranquiciaVirtual}
                />
                <Route path="/contacto" component={Contacto} />
                <Route
                  path="/promociones-bancarias"
                  component={PromocionesBancarias}
                />
                <Route path="/terminos-y-condiciones" component={Terminos} />
                <Route path="/coberturaDeSalud" component={CoberturaSalud} />
                <Route path="/programaPreventa" component={Reintegros} />
                <Route path="/reserva-flexible" component={ReservaFlexible} />
                <Route path="/formas-de-pago" component={FormasDePago} />
                <Route path="/carteleras" component={Carteleras} />
                <Route
                  path="/buscador-de-agencias"
                  component={BuscadorAgencias}
                />
                {/*
                <CdrGlobalProvider>
                  <Route exact path="/hoteles" component={Hoteles} />
                  <Route path="/hoteles/listado-de-hoteles/:destino?/:fechaIn?/:fechaOut?/:pasajeros?" component={ResultadosCdr} />
                  <Route
                  path="/hoteles/proceso-compra/login/"
                  render={LoginCdr}
                />
                  <Route
                    path="/hoteles/proceso-compra/carga-pasajeros/"
                    render={CargaPasajerosCdr}
                  />
                  <Route
                    path="/hoteles/proceso-compra/pago/"
                    render={PagoCdr}
                  />
                  <Route
                    path="/hoteles/proceso-compra/finalizacion/:estado?/:numeroReserva?"
                    render={FinalizacionCdr}
                  />
                </CdrGlobalProvider>
                */}
                {/*<Route path='/verMas/:numReserva' component={ReservaIndividual} />*/}
                {/*<Route path='/prueba' component={Prueba} />*/}
                <Route component={Page404} />
              </Switch>

              <Footer />
              <SubFooter />
            </GlobalProvider>
          </GAListener>
        </Router>
      </div>
    );
  }
}

export default App;

class Menor {
  constructor() {
    this.tipoDocumento = { idTipoDocumento: 1, sigla: "DNI" };
    this.nacionalidad = { id: 1, denominacion: "Argentina" };
    this.sexo = "M";
    this.tipoPasajero = "Menor";
    this.edad = 0;
  }
}



// WEBPACK FOOTER //
// ./src/App.js